// SP: Sticker Club subscription date calculator: "pick a date, see what
// arrives, and when." Mirrors the exact rule already written out in this
// page's own FAQ copy (templates/product.subscription.json, question
// "Which kit will I receive and when will it ship?"): subscribe on/before
// the 28th of month M -> kit themed for month M+2, ships mid-month (15th)
// of month M+1. After the 28th -> themed for month M+3, ships mid-month
// of month M+2. Verified against all 4 of that FAQ answer's worked
// examples (June/July 2026, both sides of the cutoff) before shipping.
(function () {
  const MONTH_NAMES = [
    'January', 'February', 'March', 'April', 'May', 'June',
    'July', 'August', 'September', 'October', 'November', 'December',
  ];

  const MONTH_ABBR = [
    'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
    'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec',
  ];

  function addMonths(year, monthIndex, count) {
    const total = monthIndex + count;
    return {
      year: year + Math.floor(total / 12),
      monthIndex: ((total % 12) + 12) % 12,
    };
  }

  function resolve(subscribeDate) {
    const year = subscribeDate.getFullYear();
    const monthIndex = subscribeDate.getMonth();
    const day = subscribeDate.getDate();
    const beforeCutoff = day <= 28;

    const themed = addMonths(year, monthIndex, beforeCutoff ? 2 : 3);
    const ships = addMonths(year, monthIndex, beforeCutoff ? 1 : 2);

    return {
      beforeCutoff,
      orderDateShort: `${MONTH_ABBR[monthIndex]} ${day}, ${year}`,
      orderDateLong: `${MONTH_NAMES[monthIndex]} ${day}, ${year}`,
      themedLabel: `${MONTH_NAMES[themed.monthIndex]} ${themed.year}`,
      themedShort: `${MONTH_ABBR[themed.monthIndex]} ${themed.year}`,
      shipsLabel: `Mid-${MONTH_NAMES[ships.monthIndex]} ${ships.year}`,
      shipsShort: `Mid-${MONTH_ABBR[ships.monthIndex]} ${ships.year}`,
      shipsMonthYear: `${MONTH_NAMES[ships.monthIndex]} ${ships.year}`,
    };
  }

  function renderInfographic(data) {
    const badgeText = data.beforeCutoff ? 'Order Secured' : 'Next Cycle Enrollment';
    const badgeModifier = data.beforeCutoff ? '' : ' sp-calc-infographic__badge--subsequent';
    const dotModifier = data.beforeCutoff ? '' : ' sp-calc-infographic__dot--subsequent';
    const cutoffNote = data.beforeCutoff
      ? 'Subscribed before the 28th cutoff'
      : 'Subscribed after the 28th cutoff';
    const step1Sub = data.beforeCutoff ? 'Subscription starts' : 'Subsequent cycle batch';
    const summary = data.beforeCutoff
      ? `Subscribe on ${data.orderDateLong} and your first package will be the ${data.themedLabel} kit, shipping mid-${data.shipsMonthYear} with tracked delivery.`
      : `Orders placed after the 28th enroll in the following monthly cycle. Your first package will be the ${data.themedLabel} kit, shipping mid-${data.shipsMonthYear} with tracked delivery.`;

    const arrowHtml = `
      <div class="sp-calc-infographic__arrow" aria-hidden="true">
        <svg class="sp-calc-infographic__arrow-svg" viewBox="0 0 20 8" width="18" height="8" fill="none" stroke="currentColor" stroke-width="1">
          <path d="M0 4h16M13 1l4 3-4 3" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </div>
    `;

    return `
      <div class="sp-calc-infographic">
        <div class="sp-calc-infographic__header">
          <span class="sp-calc-infographic__badge${badgeModifier}">
            <span class="sp-calc-infographic__dot${dotModifier}"></span>
            <span class="sp-calc-infographic__badge-text">${badgeText}</span>
          </span>
          <span class="sp-calc-infographic__rule-note">${cutoffNote}</span>
        </div>
        <div class="sp-calc-infographic__grid">
          <div class="sp-calc-infographic__step">
            <span class="sp-calc-infographic__step-num">01 : ORDER</span>
            <span class="sp-calc-infographic__step-val">${data.orderDateShort}</span>
            <span class="sp-calc-infographic__step-sub">${step1Sub}</span>
          </div>
          ${arrowHtml}
          <div class="sp-calc-infographic__step">
            <span class="sp-calc-infographic__step-num">02 : DISPATCH</span>
            <span class="sp-calc-infographic__step-val">${data.shipsShort}</span>
            <span class="sp-calc-infographic__step-sub">Ships by the 15th</span>
          </div>
          ${arrowHtml}
          <div class="sp-calc-infographic__step sp-calc-infographic__step--highlight">
            <span class="sp-calc-infographic__step-num">03 : FIRST KIT</span>
            <span class="sp-calc-infographic__step-val">${data.themedShort}</span>
            <span class="sp-calc-infographic__step-sub">14 sheets + bonus item</span>
          </div>
        </div>
        <p class="sp-calc-infographic__summary">${summary}</p>
      </div>
    `;
  }

  function init(form) {
    const input = form.querySelector('[data-sp-date-calculator-input]');
    const result = form.closest('.sp-sc-timeline__calc-copy')?.querySelector('[data-sp-date-calculator-result]');
    if (!input || !result) return;

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      if (!input.value) {
        result.innerHTML = '<p class="sp-calc-infographic__error" style="color:#b91c1c;margin:0.5rem 0 0;font-size:0.8125rem;">Please select a date from the calendar first.</p>';
        return;
      }
      // new Date('YYYY-MM-DD') parses as UTC midnight: use local parts from
      // valueAsDate instead so the calendar day picked is the day used.
      const picked = input.valueAsDate
        ? new Date(input.valueAsDate.getUTCFullYear(), input.valueAsDate.getUTCMonth(), input.valueAsDate.getUTCDate())
        : new Date(input.value);
      const data = resolve(picked);
      result.innerHTML = renderInfographic(data);
    });
  }

  document.querySelectorAll('[data-sp-date-calculator]').forEach(init);
})();
